<template>
  <div>
    <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
      <form @submit.prevent="update">
        <div class="d-flex align-items-center px-3">
          <div class="ml-auto">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 0 24 24"
                width="24px"
                fill="#00bea5"
            >
              <path d="M0 0h24v24H0z" fill="none"/>
              <path
                  d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
              />
            </svg>
            <span class="pr-2">تغییر رمز عبور</span>
          </div>
          <div>
            <button
                type="submit"
                class="btn btn-success px-4"
                style="border-radius: 10px"
                id="submit_btn"
                :disabled="form_submit_loading"
            >
                    <span v-if="form_submit_loading">
                      <span class="pl-2">در حال انجام</span>
                      <span
                          class="spinner-border spinner-border-sm p-2"
                          role="status"
                      ></span>
                    </span>
              <span v-else>بروزرسانی</span>
            </button>
          </div>
        </div>
        <hr/>
        <div class="p-3">
          <div class="form-group px-3">
            <label for="current_password">کلمه عبور فعلی</label>
            <input
                type="password"
                id="current_password"
                name="current_password"
                class="form-control"
            />
          </div>
          <div class="form-group px-3">
            <label for="new_password">کلمه عبور جدید</label>
            <input
                type="password"
                id="new_password"
                name="new_password"
                class="form-control"
            />
          </div>
          <div class="form-group px-3">
            <label for="new_password_confirm">تکرار کلمه عبور جدید</label>
            <input
                type="password"
                id="new_password_confirm"
                name="new_password_confirm"
                class="form-control"
            />
          </div>
        </div>
      </form>
    </div>

    <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
      <form @submit.prevent="updateSetting">
        <div class="d-flex align-items-center px-3">
          <div class="ml-auto">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                height="24px"
                viewBox="0 0 24 24"
                width="24px"
                fill="#00bea5"
            >
              <path d="M0 0h24v24H0z" fill="none"/>
              <path
                  d="M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
              />
            </svg>
            <span class="pr-2">تنظیمات ورود به پنل و برداشت کیف</span>
          </div>

          <div>
            <button
                type="submit"
                class="btn btn-success px-4"
                style="border-radius: 10px"
                id="submit"
                :disabled="loading"
            >
                    <span v-if="loading">
                      <span class="pl-2">در حال انجام</span>
                      <span
                          class="spinner-border spinner-border-sm p-2"
                          role="status"
                      ></span>
                    </span>
              <span v-else>بروزرسانی</span>
            </button>
          </div>
        </div>

        <hr>
<!--        <div class="row mr-4">-->
<!--          <div class="form-group form-check">-->
<!--            <label class="switch">-->
<!--              <input-->
<!--                  type="checkbox"-->
<!--                  id="change_password"-->
<!--                  v-model="form_data.has_two_factor_auth"-->
<!--              />-->
<!--              <span class="slider round"></span>-->
<!--            </label>-->
<!--            <label-->
<!--                for="change_password"-->
<!--                class="btn m-0 p-0 text-secondary form-check-label pr-4"-->
<!--            >احراز هویت دو عاملی (از طریق پیامک)</label>-->
<!--          </div>-->
<!--        </div>-->
        <div class="row mr-4">
          <div class="form-group form-check">
            <label
                for="two_factor_type"
                class="m-0 p-0 text-secondary form-check-label pr-4 ml-5"
            >
              نوع احراز هویت دو عاملی
            </label>
            <label>
              <select id="two_factor_type"
                      class="form-control kt-selectpicker"
                      name="two_factor_type"
                      v-model="form_data.two_factor_type"
              >
                <option :value="TwoFactorType.SMS">
                  پیامک
                </option>
                <option :disabled="!is_g2fa_active" :value="TwoFactorType.GOOGLE_AUTHENTICATOR">
                  Google authenticator
                </option>
              </select>
            </label>
          </div>
        </div>

        <div class="row mr-5 mb-3">
          <button
            class="btn"
            :class="!is_g2fa_active ? 'btn-success' : 'btn-info'"
            type="button"
            id="activate_g2fa_btn"
            @click="activateG2fa"
            v-text="!is_g2fa_active ? 'فعالسازی Google Authenticator' : 'اطلاعات Google Authenticator'"
          />
        </div>
        <p v-if="!is_g2fa_active" class="text-danger mr-5" style="font-size: 10.5px">
          برای تغییر نوع احراز هویت به Google Authenticator ابتدا باید نسبت به فعالسازی آن افدام نمایید.
        </p>
        <div id="activate_g2fa_modal" class="modal fade" role="dialog">
          <div class="modal-dialog modal-width">
            <div class="modal-content text-center">
              <div id="data_sheet" class="modal-body mb-4">
                <div class="">فعالسازی احراز هویت از طریق Google Authenticator</div>
              </div>
              <p class="text-danger font-weight-bold">در صورتی که نتوانستید QR code را اسکن کنید می توانید کد زیر را به صورتی دستی وارد کنید.</p>
              <div class="col-12 d-flex align-items-center my-4 justify-content-center">
                <div class="text-nowrap ml-5">کلید رمزنگاری Google Authenticator</div>
                <input class="form-control" type="text" :value="google2fa_secret" dir="ltr" disabled>
                <div
                    @click="copyText(google2fa_secret)"
                    class="btn m-0 pl-2 pr-0 py-1 border-success mr-2"
                    style="cursor: pointer"
                >
                  <i
                      class="fas fa-copy text-success"
                      id="btn_copy_wallet_hashid"
                  ></i>
                </div>
              </div>
              <p class="text-danger font-weight-bold">لطفا برای فعالسازی کد زیر را در اپلیکیشن Google Authenticator اسکن کنید.</p>
              <div class="mb-5 mt-3" id="qr"></div>
              <form v-if="!is_g2fa_active" @submit.prevent="activate" id="activate-form">
                <div class="form-field mb-5" style="direction: rtl">
                  <kt-form-control
                      v-bind:placeholder="$t('auth.login.google_authenticator_code')"
                      name="google_authenticator_code"
                      class="text-center"
                      autocomplete="off"
                      v-model="google_authenticator_code"
                      type="text"
                      id="google_authenticator_code"
                      dir="ltr"
                  />
                </div>
                <div class="d-flex justify-content-center mb-4">
                  <button type="submit"
                          id="active-btn"
                          class="btn btn-success col-4">
                    فعالسازی
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <!-- <div class="row mr-4">
          <div class="form-group form-check">
            <label
                for="token_expiry_time"
                class="m-0 p-0 text-secondary form-check-label pr-4 ml-5"
            >
               مدت زمان انقضای لاگین بعد از آخرین فعالیت
            </label>
            <label>
              <select id="token_expiry_time"
                      class="form-control kt-selectpicker"
                      name="token_expiry_time"
                      v-model="form_data.token_expiry_time"
              >
                <option value="1">
                  یک ساعت
                </option>
                <option value="6">
                  شش ساعت
                </option>
                <option value="12">
                  دوازده ساعت
                </option>
                <option value="24">
                  یک روز
                </option>
                <option value="168">
                  یک هفته
                </option>
              </select>
            </label>
          </div>
        </div> -->
      </form>
    </div>

    <div class="bg-white shadow-sm py-3 my-2" style="border-radius: 10px">
      <div class="d-flex align-items-center px-3">
        <div class="ml-auto">
          <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24"
              fill="#00bea5"
          >
            <path d="M80-160v-90h80v-490q0-24.75 17.625-42.375T220-800h620v60H220v490h240v90H80Zm470 0q-12.75 0-21.375-8.625T520-190v-460q0-12.75 8.625-21.375T550-680h300q12.75 0 21.375 8.625T880-650v460q0 12.75-8.625 21.375T850-160H550Zm30-90h240v-370H580v370Zm0 0h240-240Z"/>
          </svg>
          <span class="pr-2">دستگاه ها</span>
        </div>
      </div>

      <div class="px-5">
        <div class="mt-4">
          <div class="row">
            <div class="col-12">
              <div class="card bg-white shadow-sm border border-success" style="border-radius: 10px">
                <div class="card-body" v-if="currentDevice">
                  <div class="d-flex justify-content-between align-items-center border-bottom py-2">
                    <div class="d-flex align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="#00bea5" height="20" viewBox="0 -960 960 960" width="20">
                        <path d="M334-120v-60h86v-100H140q-24 0-42-18t-18-42v-440q0-24 18-42t42-18h680q24 0 42 18t18 42v440q0 24-18 42t-42 18H540v100h86v60H334ZM140-340h680v-440H140v440Zm0 0v-440 440Z"/>
                      </svg>

                      <span class="mx-2">{{ currentDevice.platform }} | {{ currentDevice.browser }}</span>

                    </div>
                    <span>فعلی</span>
                  </div>
                  <div class="d-flex flex-column mt-4 mb-2">
                    <div class="card-text d-flex items-center">
                      <p class="card-text">
                        ساخته شده در: <span>{{ currentDevice.created_at }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="d-flex flex-column mb-2">
                    <div class="card-text d-flex items-center">
                      <p class="card-text">
                        آخرین دسترسی: <span>{{ currentDevice.updated_at }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="d-flex flex-column mb-2">
                    <div class="card-text d-flex items-center">
                      <p class="card-text">
                        آی پی: <span>{{ currentDevice.ip || '-' }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-4">
          <div class="row" v-if="devices.length">
            <div class="col-lg-6 mb-4" v-for="(device , index) in devices" :key="index">
              <div class="card bg-white shadow-sm border border-success" style="border-radius: 10px">
                <div class="card-body">
                  <div class="d-flex justify-content-between align-items-center border-bottom py-2">
                    <div class="d-flex align-items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="#00bea5" height="20" viewBox="0 -960 960 960" width="20">
                        <path d="M334-120v-60h86v-100H140q-24 0-42-18t-18-42v-440q0-24 18-42t42-18h680q24 0 42 18t18 42v440q0 24-18 42t-42 18H540v100h86v60H334ZM140-340h680v-440H140v440Zm0 0v-440 440Z"/>
                      </svg>

                      <span class="mx-2">{{ device.platform }} | {{ device.browser }}</span>

                    </div>
                    <div class="btn" @click="deleteDevice(device.id , index)">
                      <svg xmlns="http://www.w3.org/2000/svg" height="18" viewBox="0 -960 960 960" fill="red" width="18">
                        <path d="M261-120q-24.75 0-42.375-17.625T201-180v-570h-41v-60h188v-30h264v30h188v60h-41v570q0 24-18 42t-42 18H261Zm438-630H261v570h438v-570ZM367-266h60v-399h-60v399Zm166 0h60v-399h-60v399ZM261-750v570-570Z"/>
                      </svg>
                    </div>
                  </div>
                  <div class="d-flex flex-column mt-4 mb-2">
                    <div class="card-text d-flex items-center">
                      <p class="card-text">
                        ساخته شده در: <span>{{ device.created_at }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="d-flex flex-column mb-2">
                    <div class="card-text d-flex items-center">
                      <p class="card-text">
                        آخرین دسترسی: <span>{{ device.updated_at }}</span>
                      </p>
                    </div>
                  </div>

                  <div class="d-flex flex-column mb-2">
                    <div class="card-text d-flex items-center">
                      <p class="card-text">
                        آی پی: <span>{{ device.ip || '-' }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import {userService} from "@/common/api.service";
import {mapState} from "vuex";

import toastr from "toastr";
import {TwoFactorType} from "@/constants/TwoFactorType";
import QrCodeWithLogo from "qr-code-with-logo";
import Inputmask from "inputmask";

export default {
  name: "change_password",
  data() {
    return {
      form_submit_loading: false,
      user: this.$store.state.user.current_user,
      loading: false,
      form_data: {
        has_two_factor_auth: this.$store.state.user.has_two_factor_auth,
        token_expiry_time: this.$store.state.user.token_expiry_time,
        two_factor_type: this.$store.state.user.two_factor_type,
        is_g2fa_active: this.$store.state.user.is_g2fa_active,
      },
      google2fa_secret: null,
      google2fa_qr_code: null,
      google_authenticator_code: null,
    };
  },

  computed: {
    TwoFactorType() {
      return TwoFactorType
    },
    ...mapState("user", {
      status: (state) => state.status,
      has_two_factor_auth: state => state.has_two_factor_auth,
      token_expiry_time: state => state.token_expiry_time,
      two_factor_type: state => state.two_factor_type,
      is_g2fa_active: state => state.is_g2fa_active,
      currentDevice: state => state.currentDevice,
      devices: state => state.devices,
    }),
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: false,
        rtl: false
      }

      return toastr
    }
  },
  watch: {
    status() {
      this.user = this.$store.state.user.current_user;
    },
    has_two_factor_auth(){
      this.form_data.has_two_factor_auth = this.$store.state.user.has_two_factor_auth;
    },
    token_expiry_time(){
      this.form_data.token_expiry_time = this.$store.state.user.token_expiry_time;
    },
    two_factor_type(){
      this.form_data.two_factor_type = this.$store.state.user.two_factor_type;
    },
    is_g2fa_active(){
      this.form_data.is_g2fa_active = this.$store.state.user.is_g2fa_active;
    }
  },
  mounted() {
    this.$store.dispatch("user/fetchCurrent");
    this.$store.dispatch("user/fetchUserSetting");
    this.$store.dispatch("user/fetchUserDevices");
  },
  methods: {
    magnifyQR() {
      setTimeout(() => {
        $('#qr').empty();
        let qr_canvas = document.createElement('img');
        document.getElementById('qr').appendChild(qr_canvas);
        QrCodeWithLogo.toImage({
          image: qr_canvas,
          content: this.google2fa_qr_code,
          width: 300,
          height: 300,
          logo: {
            src: "./favicon_new_dark.png",
            borderRadius: '50',
            bgColor: '#fff',
            logoSize: 0.25,
            borderSize: 0
          }
        })
      },5)
    },
    async activateG2fa()  {
      let btn = $('#activate_g2fa_btn')

      btn.prop("disabled", true);
      btn.html(`<div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>`);

      await this.$store.dispatch('user/fetchUserG2fa')
          .then((response) => {
            this.google2fa_secret = response.data.data.google2fa_secret
            this.google2fa_qr_code = response.data.data.google2fa_qr_code
            this.maskInput()
            this.magnifyQR()
            $('#activate_g2fa_modal').modal('show')
          })
          .finally(() => {
            btn.prop("disabled", false);
            btn.html(this.is_g2fa_active ? 'اطلاعات Google Authenticator' : 'فعالسازی Google Authenticator');
          })
    },
    activate() {
      let form = $('#activate-form')
      let btn = $('#active-btn')

      form.validate({
        ignore: ".ignore",
        rules: {
          google_authenticator_code: {
            required: true,
          },
        }
      })

      if(!form.valid()) {
        return
      }

      btn.prop("disabled", true);
      btn.html(`<div class="d-flex justify-content-center align-items-center"><div class="px-2">لطفا صبر کنید</div><div class="spinner-border spinner-border-sm text-white" role="status"></div></div>`);

      userService.activateAuthUserG2fa({
            google_authenticator_code: this.google_authenticator_code.replace(/\s+/g, '')
          })
          .then((response) => {
            this.toastr.success(response.data.message);
            $('#activate_g2fa_modal').modal('hide')
            this.$store.dispatch('user/fetchUserSetting')
          })
          .catch(({response}) => {
            this.toastr.error(response.data.message)
          })
          .finally(() => {
            btn.prop("disabled", false);
            btn.html('فعالسازی');
          })
    },
    maskInput() {
      setTimeout(() => {
        document.getElementById("google_authenticator_code") &&
        Inputmask("9     9     9     9     9     9").mask(document.getElementById("google_authenticator_code"));
      }, 100);
    },
    copyText(text) {
      navigator.clipboard.writeText(
          text
      );
      let el = document.getElementById('btn_copy_wallet_hashid');
      el.classList.remove('fa-copy');
      el.classList.add('fa-check');

      setTimeout(() => {
        el.classList.remove('fa-check');
        el.classList.add('fa-copy');
      }, 1500);
    },
    update(e) {
      let form = $(e.target);
      let btn = $("#submit_btn");

      let current_password = $("#current_password").val();

      function isPasswordChange() {
        return current_password.length > 0;
      }

      form.validate({
        ignore: ":hidden",

        rules: {
          current_password: {
            required: true,
            minlength: {
              param: 6,
            },
          },
          new_password: {
            required: isPasswordChange,
            minlength: {
              depends: isPasswordChange,
              param: 6,
            },
          },
          new_password_confirm: {
            required: isPasswordChange,
            equalTo: "#new_password",
          },
        },
      });

      if (!form.valid()) {
        return;
      }

      let params = {
        current_password: current_password,
        new_password: $("#new_password").val(),
      };

      this.form_submit_loading = true;
      userService
          .changePassword(params)
          .then((response) => {
            this.$store.commit("user/success", response.data.data);
            this.showMsg(form, "success", response.data.message);
          })
          .catch(({response}) => {
            if (response.data) {
              form.validate().showErrors(response.data.data);
            }
            this.showMsg(form, "danger", response.data.message);
          })
          .finally(() => {
            this.form_submit_loading = false;
            $("#current_password").val("");
            $("#new_password").val("");
            $("#new_password_confirm").val("");
          });
    },

    updateSetting() {
      this.loading = true;

      this.$store.dispatch('user/updateUserSetting' , this.form_data)
          .then(() => {
            this.$store.dispatch("user/fetchUserSetting");
            this.toastr.success('عملیات با موفقیت انجام شد.')
            this.loading = false;
          })
          .catch(() => {
            this.toastr.error('عملیات با خطا مواجه شد.')
            this.loading = false;
          })
    },

    deleteDevice(id){
      if (window.confirm('آیا از حذف این آیتم مطمئنید؟')){
       this.$store.dispatch('user/deleteUserDevice' , id)
            .then(async () => {
              await this.$store.dispatch('user/fetchUserDevices')
              this.toastr.success('عملیات با موفقیت انجام شد.')
            })
            .catch(() => {
              this.toastr.error('عملیات با شکست مواجه شد.')
            })
      }
    },

    showMsg(form, type, message) {
      let alert = form.closest('.alert');

    }
  },
};
</script>

<style scoped>

</style>